export enum OrgSpaceRoute {
  Create = 'create',
  Select = 'select',
}
